import { IRecipeCard } from '@seb/web-design-system/recipe-card';

export const recipeCardSkeleton: IRecipeCard = {
  title: 'title',
  media: { url: 'url' }
};
